import { axios, def, handleError } from './internal';
import { storage } from '@goldblack/client-storage';

function AdminMlStatus(setData) {
    setData((prev) => ({ ...prev, loading: true }));
    axios
        .post('/api/admin_ml_status')
        .then((res) => {
            if (res.data.code === def.ErrorCode.OK) {
                setData({ loading: false, data: res.data.data });
            } else {
                setData((prev) => ({ ...prev, loading: false }));
            }
        })
        .catch((err) => {
            setData((prev) => ({ ...prev, loading: false }));
            handleError(err);
        });
}

function AdminMlTemplates(setData) {
    axios
        .post('/api/admin_ml_templates')
        .then((res) => {
            if (res.data.code === def.ErrorCode.OK) setData({ loading: false, data: res.data.data });
            else setData((prev) => ({ ...prev, loading: false }));
        })
        .catch((err) => {
            setData((prev) => ({ ...prev, loading: false }));
            handleError(err);
        });
}

function AdminMlResync(onDone) {
    axios
        .post('/api/admin_ml_resync')
        .then((res) => onDone?.(res.data.code === def.ErrorCode.OK ? null : (res.data.message ?? 'Failed')))
        .catch((err) => {
            handleError(err);
            onDone?.('Request failed');
        });
}

function AdminMlScaleUp(aws_launch_template_id, aws_launch_template_name, region, onDone) {
    axios
        .post('/api/admin_ml_scale_up', { aws_launch_template_id, aws_launch_template_name, region })
        .then((res) => onDone(res.data.code === def.ErrorCode.OK ? null : (res.data.message ?? 'Failed')))
        .catch((err) => {
            handleError(err);
            onDone('Request failed');
        });
}

function AdminMlScaleDown(instance_id, template_id, region, onDone) {
    axios
        .post('/api/admin_ml_scale_down', { instance_id, template_id, region })
        .then((res) => onDone(res.data.code === def.ErrorCode.OK ? null : 'Failed'))
        .catch((err) => {
            handleError(err);
            onDone('Request failed');
        });
}

function AdminMlAmis(region, setData) {
    const cached = storage.transience.getValue('infrastructure').amis[region];
    if (cached) {
        setData(cached);
        return;
    }
    axios
        .post('/api/admin_ml_amis', { region })
        .then((res) => {
            if (res.data.code === def.ErrorCode.OK) {
                storage.transience.setState(`infrastructure.amis.${region}`, res.data.data);
                setData(res.data.data);
            }
        })
        .catch((err) => handleError(err));
}

function AdminMlRegions() {
    if (storage.transience.getValue('infrastructure').regions.length) return;
    axios
        .post('/api/admin_ml_regions')
        .then((res) => {
            if (res.data.code === def.ErrorCode.OK)
                storage.transience.setState('infrastructure.regions', res.data.data);
        })
        .catch((err) => handleError(err));
}

function AdminMlInstanceTypes(region) {
    if (storage.transience.getValue('infrastructure').instanceTypes.length) return;
    axios
        .post('/api/admin_ml_instance_types', { region })
        .then((res) => {
            if (res.data.code === def.ErrorCode.OK)
                storage.transience.setState('infrastructure.instanceTypes', res.data.data);
        })
        .catch((err) => handleError(err));
}

function AdminMlAwsLaunchTemplates(region, force = false) {
    if (!force && storage.transience.getValue('infrastructure').awsLaunchTemplates.length) return;
    axios
        .post('/api/admin_ml_aws_launch_templates', { region })
        .then((res) => {
            if (res.data.code === def.ErrorCode.OK)
                storage.transience.setState('infrastructure.awsLaunchTemplates', res.data.data);
        })
        .catch((err) => handleError(err));
}

export {
    AdminMlStatus,
    AdminMlTemplates,
    AdminMlResync,
    AdminMlScaleUp,
    AdminMlScaleDown,
    AdminMlAmis,
    AdminMlRegions,
    AdminMlInstanceTypes,
    AdminMlAwsLaunchTemplates,
};
